// extracted by mini-css-extract-plugin
export default {"slider_style":"Slider_slider_style","minStop":"Slider_minStop","maxStop":"Slider_maxStop"};